import { SearchActionType } from '@modules/feed/components/SearchAnalysisToolbar/Actions/SaveSearchActions';
import { useIsSearchEditable } from '@modules/feed/components/SearchAnalysisToolbar/hooks/useIsSearchEditable';
import { isSavedSearch } from '@modules/feed/components/SearchAnalysisToolbar/utils';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { useMemo } from 'react';

export const useGetSaveSearchActionType = () => {
  const id = useSearchStore(({ data: { id } = {} }) => id);

  const isEditable = useIsSearchEditable();

  const actionType = useMemo(() => {
    if (!isSavedSearch(id)) {
      return SearchActionType.SAVE;
    }

    if (isEditable) {
      return SearchActionType.SAVE_UPDATE;
    }

    return SearchActionType.SAVE_AS;
  }, [id, isEditable]);

  return actionType;
};
